<div class="w-full h-full p-10 flex flex-col">
  <button mat-raised-button class="!bg-white m-3 self-end" (click)="openUserDialog()">
    <mat-icon>add</mat-icon> Benutzer anlegen
  </button>
  <div class="grow">
    <ag-grid-angular
      class="ag-theme-alpine w-full h-full"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowData]="rowData$ | async"
      [rowSelection]="'multiple'"
      [animateRows]="true"
      [enableCellTextSelection]=true
      (cellEditingStopped)="onCellEditingStopped($event)"
      (gridReady)="onGridReady($event)"
    ></ag-grid-angular>
  </div>
</div>
